import React from 'react';
import { Award, Shield, Star, Sparkles } from 'lucide-react';

/**
 * TierBadge — small pill chip showing a driver or customer tier.
 * Accepts either an object like {tier, label, hex} or a plain tier string.
 */
const ICONS = { bronze: Award, silver: Award, gold: Star, platinum: Shield, super: Sparkles };
const LABELS = { bronze: 'Bronze', silver: 'Silver', gold: 'Gold', platinum: 'Platinum', super: 'Super' };
const HEX = { bronze: '#B87333', silver: '#A5B4B9', gold: '#D4AF37', platinum: '#5A6B7A', super: '#7C3AED' };

const TierBadge = ({ tier, size = 'sm', className = '', label: labelProp }) => {
  const t = typeof tier === 'string' ? tier : tier?.tier;
  if (!t) return null;
  const key = String(t).toLowerCase();
  const Icon = ICONS[key] || Award;
  const label = labelProp || tier?.label || LABELS[key] || key;
  const hex = tier?.hex || HEX[key] || '#94A3B8';
  const isLg = size === 'lg';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wider ${isLg ? 'text-xs px-2.5 py-1' : 'text-[10px] px-2 py-0.5'} ${className}`}
      style={{ backgroundColor: `${hex}20`, color: hex, border: `1px solid ${hex}40` }}
      data-testid={`tier-badge-${key}`}
      title={`${label} tier`}
    >
      <Icon className={isLg ? 'h-3.5 w-3.5' : 'h-3 w-3'} />
      {label}
    </span>
  );
};

export default TierBadge;
